import { CircularProgress, Typography, Stack } from "@mui/material";

const LoadingScreen: React.FC<{ message?: string }> = ({ message }) => (
  <Stack alignItems="center" spacing={2}>
    <CircularProgress size={40} />
    <Typography variant="body1" color="text.secondary">
      {message || "Loading..."}
    </Typography>
  </Stack>
);

export default LoadingScreen;
